import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "news-manage-content" }
const _hoisted_2 = { class: "add-button" }
const _hoisted_3 = { class: "table" }
const _hoisted_4 = { class: "page" }

import { nextTick, onBeforeUnmount, onMounted, Reactive, reactive, ref, Ref, shallowRef, watch } from 'vue';
import Pagination from '../Pagination.vue';
import { BaseResponse, GetNewsDetailsResponse, GetNewsListResponse } from '@/typeDefine/HttpResponseType';
import { Action, FormType } from '@/typeDefine/CommonTypes';
import { Api } from '@/http/Api';
import { UtilMethods } from '@/util/UtilMethods';
import { ResponseCode } from '@/http/ResponseCode';
import { ElMessageBox, FormInstance, FormRules } from 'element-plus';
import { NewsType } from '@/typeDefine/EntityType';
import Editor, { EditorComponentType } from './Editor.vue';

//当前页

export default /*@__PURE__*/_defineComponent({
  __name: 'NewsManage',
  setup(__props) {

const currentPage: Ref<number> = ref(1)
//页大小
const pageSize: Ref<number> = ref(10)
//总页数
const totalPage: Ref<number> = ref(0)

//是否打开弹窗
const isOpendrawer: Ref<boolean> = ref(false)

//表格内容
const tableData: Ref<GetNewsListResponse['data']['news']> = ref([])

const ruleFormRef: Ref<FormInstance | undefined> = ref()

//当前表单状态
const formType: Ref<FormType> = ref('none')

//当前选中的id
const currentNewsId: Ref<number> = ref(0)

/**
* 富文本相关字段
*/
const editorRef: Ref<EditorComponentType | null> = ref(null)
const valueHtml: Ref<string> = ref('')
const disabled: Ref<boolean> = ref(false)

const ruleForm: Reactive<Pick<NewsType, 'title' | 'author' | 'content'>> = reactive({
    title: '',
    content: '',
    author: ''
})

const rules: Reactive<FormRules<Pick<NewsType, 'title' | 'author' | 'content'>>> = reactive({
    title: [
        {
            required: true, message: '请输入标题', trigger: 'blur',
        },
        {
            max: 255, message: '最大输入255个字符', trigger: 'blur'
        }
    ],
    author: [
        {
            max: 255, message: '最大输入255个字符', trigger: 'blur'
        }
    ],
    content: [
        {
            required: true, message: '请输入内容', trigger: 'blur',
        },
    ]
})

onMounted(() => requestTableData(currentPage.value))

const requestTableData: Action<[number]> = async (currentPage: number) => {
    const response: GetNewsListResponse = await Api.instance.getNewsListByPage({ startPage: currentPage })

    UtilMethods.showMessageToast(response, false)
    if (response.code === ResponseCode.OK) {
        tableData.value = response.data.news
        totalPage.value = response.data.totalPage

        let i: number = 0
        tableData.value = tableData.value.map(item => {
            return {
                order: ++i,
                ...item
            }
        })

    }
}

const onAdd: Action = () => {
    isOpendrawer.value = true
    formType.value = 'add'
}

//当前页改变
const pageChange: Action<[number]> = (value: number) => {
    requestTableData(value)
}

//监听富文本的文字
const onChange: Action<[string]> = (value: string) => {
    ruleForm.content = value
}

//刷新
const refresh: Action = () => {
    currentPage.value = 1
    requestTableData(currentPage.value)
}

//抽屉关闭
const onDrawerClosed: Action = () => {
    disabled.value = false

    for (const item in ruleForm) {
        ruleForm[item as keyof typeof ruleForm] = ''
    }

    editorRef.value?.clear()
}

//提交新闻
const submitForm: Action<[FormInstance | undefined]> = async (formEl: FormInstance | undefined) => {
    if (!formEl) return
    await formEl.validate(async (valid, fields) => {

        if (!valid) {
            return
        }

        const response: BaseResponse = await Api.instance.addNews({
            title: ruleForm.title,
            author: ruleForm.author,
            content: valueHtml.value
        })

        UtilMethods.showMessageToast(response)

        if (response.code === ResponseCode.OK) {
            refresh()
        }
    })
}

//更新新闻
const onUpdateNewsHandler: Action<[FormInstance | undefined]> = async (formEl: FormInstance | undefined) => {
    if (!formEl) return
    await formEl.validate(async (valid, fields) => {

        if (!valid) {
            return
        }

        const response: BaseResponse = await Api.instance.updateNews({
            id: currentNewsId.value,
            title: ruleForm.title,
            author: ruleForm.author,
            content: valueHtml.value
        })

        UtilMethods.showMessageToast(response)

        if (response.code === ResponseCode.OK) {
            refresh()
        }
    })
}

//删除新闻
const onDeleteHandler: Action<[number]> = (id: number) => {
    ElMessageBox.confirm('将执行删除该新闻操作,是否确定?', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
    }).then(async () => {
        const response: BaseResponse = await Api.instance.deleteNews({
            id,
        })

        UtilMethods.showMessageToast(response)

        if (response.code === ResponseCode.OK) {
            refresh()
        }
    }).catch(() => { })
}

//将表单值设置成指定值
const setRuleFormValue: Action<[number, boolean, FormType]> = async (id: number, isDisabled: boolean, type: FormType) => {
    disabled.value = isDisabled
    isOpendrawer.value = true
    formType.value = type
    currentNewsId.value = id

    const response: GetNewsDetailsResponse = await Api.instance.getNewsDetails({ id })

    UtilMethods.showMessageToast(response, false)

    if (response.code === ResponseCode.OK) {
        const { author, title, content } = response.data.details
        ruleForm.author = author
        ruleForm.title = title

        editorRef.value?.setHtml(content)
    }
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: onAdd
        }, {
          default: _withCtx(() => _cache[7] || (_cache[7] = [
            _createTextVNode("新增新闻")
          ])),
          _: 1,
          __: [7]
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "title" }, "新闻管理", -1)),
        _createVNode(_component_el_table, {
          data: tableData.value,
          style: {"width":"100%"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "order",
              label: "序号"
            }),
            _createVNode(_component_el_table_column, {
              prop: "title",
              label: "标题"
            }),
            _createVNode(_component_el_table_column, {
              prop: "author",
              label: "作者"
            }),
            _createVNode(_component_el_table_column, {
              prop: "createTime",
              label: "发布时间"
            }),
            _createVNode(_component_el_table_column, {
              prop: "updateTime",
              label: "更新时间"
            }),
            _createVNode(_component_el_table_column, { label: "操作" }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_button, {
                  size: "small",
                  type: "primary",
                  onClick: ($event: any) => (setRuleFormValue(row.id, true, 'qeury'))
                }, {
                  default: _withCtx(() => _cache[8] || (_cache[8] = [
                    _createTextVNode("详情")
                  ])),
                  _: 2,
                  __: [8]
                }, 1032, ["onClick"]),
                _createVNode(_component_el_button, {
                  size: "small",
                  type: "success",
                  onClick: ($event: any) => (setRuleFormValue(row.id, false, 'update'))
                }, {
                  default: _withCtx(() => _cache[9] || (_cache[9] = [
                    _createTextVNode("修改")
                  ])),
                  _: 2,
                  __: [9]
                }, 1032, ["onClick"]),
                _createVNode(_component_el_button, {
                  size: "small",
                  type: "danger",
                  onClick: ($event: any) => (onDeleteHandler(row.id))
                }, {
                  default: _withCtx(() => _cache[10] || (_cache[10] = [
                    _createTextVNode(" 删除 ")
                  ])),
                  _: 2,
                  __: [10]
                }, 1032, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(Pagination, {
          "page-size": pageSize.value,
          "current-page": currentPage.value,
          "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((currentPage).value = $event)),
          "total-page": totalPage.value,
          onCurrentPageChange: pageChange
        }, null, 8, ["page-size", "current-page", "total-page"])
      ])
    ]),
    _createVNode(_component_el_drawer, {
      modelValue: isOpendrawer.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((isOpendrawer).value = $event)),
      title: "新增新闻",
      size: "50%",
      onClosed: onDrawerClosed
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref_key: "ruleFormRef",
          ref: ruleFormRef,
          style: {"max-width":"600px"},
          model: ruleForm,
          rules: disabled.value ? null : rules,
          "label-width": "auto",
          disabled: disabled.value
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "新闻标题",
              prop: "title"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: ruleForm.title,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((ruleForm.title) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "作者",
              prop: "author"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: ruleForm.author,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((ruleForm.author) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "新闻内容",
              prop: "content"
            }, {
              default: _withCtx(() => [
                _createVNode(Editor, {
                  ref_key: "editorRef",
                  ref: editorRef,
                  "value-html": valueHtml.value,
                  "onUpdate:valueHtml": _cache[3] || (_cache[3] = ($event: any) => ((valueHtml).value = $event)),
                  mode: 'default',
                  placeholder: '请输入新闻内容',
                  onOnChange: onChange,
                  disabled: disabled.value
                }, null, 8, ["value-html", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                (formType.value === 'add')
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      type: "primary",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (submitForm(ruleFormRef.value)))
                    }, {
                      default: _withCtx(() => _cache[12] || (_cache[12] = [
                        _createTextVNode(" 提交 ")
                      ])),
                      _: 1,
                      __: [12]
                    }))
                  : (formType.value === 'update')
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 1,
                        type: "success",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (onUpdateNewsHandler(ruleFormRef.value)))
                      }, {
                        default: _withCtx(() => _cache[13] || (_cache[13] = [
                          _createTextVNode(" 更新 ")
                        ])),
                        _: 1,
                        __: [13]
                      }))
                    : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules", "disabled"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})